import React from 'react'

export default class ChartBuilderDataSourcesSelect extends React.Component{
  constructor(props){
    super(props);
    this.dataSourceSelect = React.createRef();
  };

  componentDidMount(){
    this.initSelect2();
  };

  componentDidUpdate(prevProps, prevState){
    if(this.props.error) {
      $(`#select2-${this.props.detail.id}-data-source-container`).addClass('has-errors');
    } else{
      $(`#select2-${this.props.detail.id}-data-source-container`).hasClass('has-errors') ? $(`#select2-${this.props.detail.id}-data-source-container`).removeClass('has-errors') : null;
    };
    // var dataSourceOptions = this.state.options.map((option) => {
    //   if (this.props.detail.data_source && option.value === this.props.detail.data_source.id) {
    //     option.selected = 'selected'
    //   } else {
    //     option.selected = ''
    //   };
    //   return option
    // });
    
    // $(`#${this.props.detail.id}-data-source`).multiselect({
    //   AllSelectedText: 'All',
    //   onChange: (option, checked) => {
    //     if(checked){
    //       this.props.onChangeDataDetailDataSource(this.props.detail.id, option[0].value)
    //     };
    //     if(!checked){
    //       this.props.onChangeDataDetailDataSource(this.props.detail.id, null)
    //     };
    //   }
    // })
    //   .multiselect('dataprovider', dataSourceOptions)
    //   .multiselect('updateButtonText')

    //   if (this.props.error && !prevProps.error ){
    //     $(`#${this.props.detail.id}-data-source`).next('.btn-group').find('.multiselect.dropdown-toggle.btn.btn-dark').addClass('has-errors')
    //     $(`#${this.props.detail.id}-data-source`).next('.btn-group').after(`<div class="help-block"><ul>${I18n.t('cant_be_blank')}</ul></div>`)
    //   } else if(prevProps.error && !this.props.error){
    //     $(`#${this.props.detail.id}-data-source`).next('.btn-group').find('.multiselect.dropdown-toggle.btn.btn-dark').removeClass('has-errors')
    //     $(`#${this.props.detail.id}-data-source`).next('.btn-group').next('.help-block').remove()
    //   };
  };

  render(){
    return(
      [
        <select key={`${this.props.detail.id}-data-source-select`} id={`${this.props.detail.id}-data-source`} ref={this.dataSourceSelect} className="form-control">
          <option></option>
        </select>,
        this.props.error
        ?
        <div className="help-block" key={`${this.props.detail.id}-data-source-error-block`}>
          <ul>{I18n.t('cant_be_blank')}</ul>
        </div>
        :
        null
      ]
    );
  };

  initSelect2(){
    $(this.dataSourceSelect.current).select2({
      data: this.setDataSourceOptions(),
      allowClear: true,
      placeholder: I18n.t('select_ellipsis'),
    }).on('change.select2', (e) => {
      this.props.onChangeDataDetailDataSource(this.props.detail.id, e.target.value ? e.target.value : null);
    });
  };

  setDataSourceOptions(){
    return this.props.dataSources.map((ds) => {
      return({
        id: ds.id,
        text: ds.system_data ? I18n.t(ds.name) : ds.name,
        selected: this.props.detail && this.props.detail.data_source && this.props.detail.data_source.id === ds.id ? true : false,
      });
    });
  };

};